import React from 'react'

import TableHeader from './header'
import Row from './row'
import './list.css'
import './table-column-sizes.css'
import ReactTooltip from 'react-tooltip'
import ACLCheckPermission from '../ACLCheckPermission'

export default ({ list, offset, size, loading, onchange, onEdit, onSave, onFilterChange, onSellerEdit, onRemove, onLoginAs, canCreateSubPartners, onLoadMore }) => {
    return (
        <div>
            <div className="row">
                <div className="col-10">
                    {!canCreateSubPartners && (
                        <div className="alert alert-warning" role="alert">
                            This partner is not enabled to create sub partners!
                        </div>
                    )}

                    {canCreateSubPartners && (
                        <div className="add-segment add-segment--search-field">
                            <input
                                className="form-control"
                                placeholder="Start typing a partner name..."
                                onChange={({ target }) => onFilterChange(target)}

                            />
                        </div>
                    )}
                

                </div>
                <div className="col-2">
                    <div className="text-right">
                        <ReactTooltip id="loginAsBtnTooltip" type="dark" effect="solid">
                            <span>Login as this partner</span>
                        </ReactTooltip>

                        <ACLCheckPermission api="/partner" method="POST">
                            <ReactTooltip id="createBtnTooltip" type="dark" effect="solid">
                                <span>Create a new Partner</span>
                            </ReactTooltip>
                            <button
                                data-tip
                                data-for="createBtnTooltip"
                                disabled={!canCreateSubPartners}
                                onClick={() => window.location.href = '/settings/partner/new'}
                                className="border-button inlinebuttons">
                                New partner
                            </button>
                        </ACLCheckPermission>
                    </div>
                </div>
            </div>
            <table className="license-list license-list--table">
                <TableHeader />
                <tbody>
                    {list.map((r, index) => (
                        <Row
                            onLoginAs={onLoginAs}
                            onSave={onSave}
                            onSellerEdit={onSellerEdit}
                            onRemove={onRemove}
                            onchange={onchange}
                            onEdit={onEdit}
                            index={index}
                            key={index}
                            row={r}
                        />
                    ))}
                    
                    
                    {!loading && list.length >= offset + size && (
                        <tr>
                            <td colSpan={8} style={{ textAlign: 'center' }}>
                                <button type="button" className="btn btn-link property-list property-list--load-more-button" onClick={onLoadMore}>
                                    Load more
                                </button>
                            </td>
                        </tr>
                    )}
                    {loading && (
                        <tr>
                            <td colSpan={8} style={{ textAlign: 'center' }}>
                                <button type="button" className="btn btn-link property-list property-list--load-more-button" disabled>
                                    Loading...
                                </button>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}
